module.exports = __webpack_public_path__ + "img/homepod.e3172634.png";